import { render, staticRenderFns } from "./position-row.component.vue?vue&type=template&id=1c90d10c&scoped=true"
import script from "./position-row.component.vue?vue&type=script&lang=js"
export * from "./position-row.component.vue?vue&type=script&lang=js"
import style0 from "./position-row.component.vue?vue&type=style&index=0&id=1c90d10c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c90d10c",
  null
  
)

export default component.exports